
import { AUTO, Game as PhaserGame, Scale } from 'phaser';
import { GAME } from './config/constants';
import { ARCADE } from './config/theme';
import { ligarAjusteDeTela } from './services/ajusteDeTela';
import { calcularTela, ligarTelaLarga } from './services/telaLarga';

import { Boot } from './scenes/Boot';
import { Preloader } from './scenes/Preloader';
import { LoginScene } from './scenes/LoginScene';
import { AguardeScene } from './scenes/AguardeScene';
import { EmBreveScene } from './scenes/EmBreveScene';
import { MenuResolucaoScene } from './scenes/MenuResolucaoScene';
import { MateriaisScene } from './scenes/MateriaisScene';
import { MuralScene } from './scenes/MuralScene';
import { RankingScene } from './scenes/RankingScene';
import { ScanPixelResultadoScene } from './scenes/ScanPixelResultadoScene';
import { LabPixelsResultadoScene } from './scenes/LabPixelsResultadoScene';
import { Game } from './scenes/Game';
import { QuizScene } from './scenes/QuizScene';
import { Player1Scene } from './scenes/Player1Scene';
import { Player1ResultadoScene } from './scenes/Player1ResultadoScene';
import { VersusScene } from './scenes/VersusScene';
import { VersusArgumentoScene } from './scenes/VersusArgumentoScene';
import { VersusResultadoScene } from './scenes/VersusResultadoScene';
import { BossFinalScene } from './scenes/BossFinalScene';
import { TelaEsperaTelaoScene } from './scenes/TelaEsperaTelaoScene';

const config = {
    type: AUTO,
    width: GAME.WIDTH,
    height: GAME.HEIGHT,
    backgroundColor: ARCADE.GRAFITE,
    // Tablet 1920x1200 estica o canvas 1280x800 em 1,5x (fracionário): sem isso o filtro
    // linear borra tudo. pixelArt = antialias off + roundPixels.
    render: {
        pixelArt: true
    },
    scale: {
        mode: Scale.FIT,
        autoCenter: Scale.CENTER_BOTH,
        orientation: Scale.Orientation.LANDSCAPE
    },
    dom: {

        createContainer: true
    },

    scene: [
        Boot,
        Preloader,
        LoginScene,
        AguardeScene,
        EmBreveScene,
        MenuResolucaoScene,
        MateriaisScene,
        MuralScene,
        RankingScene,
        Game,
        ScanPixelResultadoScene,
        QuizScene,
        LabPixelsResultadoScene,
        Player1Scene,
        Player1ResultadoScene,
        VersusScene,
        VersusArgumentoScene,
        VersusResultadoScene,
        BossFinalScene,
        TelaEsperaTelaoScene
    ]
};

/**
 * @param {string} parent id do elemento que recebe o canvas
 * @param {object} servicos
 * @param {object} servicos.fonte fonte de dados já resolvida (dev ou prd)
 * @param {Function[]} [servicos.cenas] cenas no lugar das do participante
 *   (build do facilitador); Boot e Preloader são sempre os mesmos
 * @param {Record<string, any>} [servicos.registro] entradas extras do registry
 */
const StartGame = (parent, { fonte, cenas = null, registro = {} } = {}) => {
    // Participante e facilitador: o canvas ganha a largura da janela (celular 20:9) em vez de
    // faixas laterais. No tablet 16:10 a largura é 1280 e nada muda.
    const { largura } = calcularTela(window.innerWidth, window.innerHeight);
    const jogo = new PhaserGame({
        ...config,
        width: largura,
        ...(cenas ? { scene: [Boot, Preloader, ...cenas] } : {}),
        parent,
        callbacks: {
            // Antes do boot das cenas: toda cena lê a fonte pelo registry.
            preBoot: (game) => {
                game.registry.set('fonte', fonte);
                Object.entries(registro).forEach(([chave, valor]) => game.registry.set(chave, valor));
            }
        }
    });
    // O canvas acompanha a janela mesmo quando o WebView não avisa a mudança de tamanho.
    ligarAjusteDeTela(jogo);
    // A área de 1280 fica centrada no canvas largo e acompanha mudança de proporção da janela.
    ligarTelaLarga(jogo);
    return jogo;
};

export default StartGame;
